import { render, staticRenderFns } from "./employeesDialog.vue?vue&type=template&id=22474812&"
import script from "./employeesDialog.vue?vue&type=script&lang=js&"
export * from "./employeesDialog.vue?vue&type=script&lang=js&"
import style0 from "./employeesDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports